import React from 'react';
import { useCompany } from '../hooks';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';

interface CompanyFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
	disabled?: boolean;
	allowClear?: boolean;
}

export function CompanyFormItem({
	required = true,
	allowClear = false,
	disabled = false,
	fieldName
}: Readonly<CompanyFormItemProps>): JSX.Element {
	const { items, isFetching, companyId, handleOnChange, handleOnClear } = useCompany({ fieldName });

	return (
		<FormItem
			name={fieldName}
			required={required}
			label="Industrial site"
			requiredMessage="Please select a industrial site"
		>
			<Select
				options={items}
				value={companyId}
				loading={isFetching}
				allowClear={allowClear}
				onClear={handleOnClear}
				onChange={handleOnChange}
				placeholder="Industrial site"
				disabled={disabled}
			/>
		</FormItem>
	);
}
